import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import '../styles/ArticlePostComment.css';
import isEmail from 'validator/lib/isEmail';
import getRecaptchaToken from '../helpers/getRecaptchaToken';
import AppContext from './context/AppContext';

const invalidNameRegExp = /[^A-Za-z\-' ]/g;

const ArticlePostComment = ({ articleId }) => {
    const { appContext } = useContext(AppContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        if (!name || !email || !message) 
            return;
        try {
            const response = await fetch(
                new URL('/api/comments', process.env.APP_URL),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({
                        name,
                        email,
                        message,
                        articleId: String(articleId),
                        token: await getRecaptchaToken(appContext.config.recaptchaSiteKey),
                    }),
                }
            );
            const data = await response.json();
            if (!response.ok || data.error) 
                throw new Error(data.error ?? 'Something went wrong.');
            setSuccess(true);
            setName('');
            setEmail('');
            setMessage('');
        } catch (e) {
            setErrorMessage(e.message);
            console.error(e);
        }
    };
    useEffect(() => {
        let successTimer = null;
        const SUCCESS_TIMEOUT_MS = 3000;
        const successTimerFunc = () => setSuccess(false);
        if (success === true) {
            setTimeout(successTimerFunc, SUCCESS_TIMEOUT_MS);
        }
        return () => {
            clearTimeout(successTimer);
        };
    }, [success]);
    return (<div
        className={'article-new-post--container'}>
        <h3>Leave a comment</h3>
        <p>Comments may require approval prior to appearing.</p>
        <Form
            onSubmit={handleSubmit}>
            <Form.Group
                className={'mb-3'}
                controlId={'postCommentForm.name'}>
                <Form.Label>Name</Form.Label>
                <Form.Control
                    name={'post-name'}
                    type={'text'}
                    placeholder={'Your name*'}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    isValid={name.length > 0 && !name.match(invalidNameRegExp)}
                    isInvalid={name.match(invalidNameRegExp) !== null || name.length > 255}
                    required />
            </Form.Group>
            <Form.Group
                className={'mb-3'}
                controlId={'postCommentForm.email'}>
                <Form.Label>Email</Form.Label>
                <Form.Control
                    name={'post-email'}
                    type={'text'}
                    placeholder={'Email address*'}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    isValid={isEmail(email)}
                    required />
            </Form.Group>
            <Form.Group
                className={'mb-3'}
                controlId={'postCommentForm.message'}>
                <Form.Label>Message</Form.Label>
                <Form.Control
                    as={'textarea'}
                    rows={3}
                    placeholder={'Your message*'}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    isValid={message.length >= 3 && message.length <= 1500} />
            </Form.Group>
            <p>* Required fields</p>
            <Button
                className={'custom-btn'}
                type={'submit'}
                onClick={handleSubmit}
                disabled={(!name || !email || !message)}>Post comment</Button>
            {errorMessage !== '' && (<>
                <br />
                <p
                    style={{ color: 'red' }}>{errorMessage}</p>
            </>)}
            {success === true && (<>
                <br />
                <p
                    style={{ color: 'green' }}>Your message has been received. Thank you.</p>
            </>)}
        </Form>
    </div>);
};

ArticlePostComment.propTypes = {
    articleId: PropTypes.number,
};

export default ArticlePostComment;